import type { FC } from "react";

const StatusBadge: FC<{ label: string; active?: boolean }> = ({
  label,
  active,
}) => (
  <div
    className={`inline-flex items-center gap-2 rounded-full px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.2em] ${
      active
        ? "bg-accentGreen/15 text-accentGreen"
        : "border border-white/[0.08] text-white/35"
    }`}
  >
    {active && (
      <span className="relative flex size-2">
        <span className="absolute inline-flex size-full animate-ping rounded-full bg-accentGreen opacity-50" />
        <span className="relative inline-flex size-2 rounded-full bg-accentGreen" />
      </span>
    )}
    {label}
  </div>
);

export default StatusBadge;
